import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'commaReplacesDot'})
export class CommaReplacesDot implements PipeTransform {
  public transform(value: string): string {
    return value.replace('.', ',');
  }
}
